import { CommonModule } from '@angular/common';
import { BarChartModule } from 'ChartApp/ts/features/bar-chart/bar-chart.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { HoldingsComparisonTableModule } from 'SecuritiesApp/ts/features/holdings-comparison-table/holdings-comparison-table.module';
import { TopHoldingsModule } from 'SecuritiesApp/ts/features/top-holdings/top-holdings.module';
import { HoldingsOverlapComponent } from './holdings-overlap.component';
import { CommonHoldingsComparisonTableComponent } from 'SecuritiesApp/ts/features/holdings-overlap/components/common-holdings-comparison/common-holdings-comparison.component';
import { SectorExposureComparisonChart } from 'SecuritiesApp/ts/features/holdings-overlap/components/sector-exposure-comparison/sector-exposure-comparison.component';
import * as i0 from "@angular/core";
export class HoldingsOverlapModule {
}
HoldingsOverlapModule.ɵfac = function HoldingsOverlapModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsOverlapModule)(); };
HoldingsOverlapModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsOverlapModule, bootstrap: [HoldingsOverlapComponent, SectorExposureComparisonChart, CommonHoldingsComparisonTableComponent] });
HoldingsOverlapModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [LoadingSymbolModule,
        IconModule,
        AddButtonAutocompleteModule,
        BaseAutocompleteModule,
        CommonModule,
        TooltipModule,
        HoldingsComparisonTableModule,
        BarChartModule,
        TopHoldingsModule,
        SingleSelectDropdownModule] });
